import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punesadeteenshaktipeeth() {



    const cardData = {

keyword: "Pune Sade Teen Shakti Peeth Bus on Rent",

headingDescription:
    "Rising Cab Service offers reliable Pune Sade Teen Shakti Peeth Bus on Rent services for pilgrims, families, and large groups planning a spiritual journey across Maharashtra. Our well-maintained buses and tempo travellers provide a safe and comfortable travel experience for long-distance temple tours. With experienced drivers, flexible itineraries, and 24/7 booking support, we ensure a smooth pilgrimage covering all major Shakti Peeth temples. We focus on safety, punctuality, and comfort, making your religious journey peaceful and well-organized.",

topPlaces: [
    {
        title: "Mahalakshmi Temple Kolhapur",
        description:
            "Mahalakshmi Temple in Kolhapur is one of the most important Shakti Peeths dedicated to Goddess Mahalakshmi. The ancient temple is known for its beautiful architecture, spiritual energy, and deep religious significance. Devotees believe that visiting this temple brings prosperity and blessings of the Goddess. The temple becomes especially vibrant during Navratri celebrations."
    },
    {
        title: "Tulja Bhavani Temple Tuljapur",
        description:
            "Tulja Bhavani Temple is one of the most powerful Shakti Peeths in Maharashtra dedicated to Goddess Bhavani. It is considered the family deity of Chhatrapati Shivaji Maharaj. The temple is located on a hill and attracts thousands of devotees seeking strength, protection, and blessings."
    },
    {
        title: "Renuka Devi Temple Mahur",
        description:
            "Renuka Devi Temple in Mahur is a highly revered Shakti Peeth associated with Goddess Renuka, the mother of Lord Parshuram. Surrounded by hills and natural beauty, the temple is an important pilgrimage site known for its peaceful atmosphere and religious importance."
    },
    {
        title: "Saptashrungi Devi Temple",
        description:
            "Saptashrungi Devi Temple is located on a steep hill near Nashik and is one of the 51 Shakti Peeths in India. The temple is dedicated to Goddess Saptashrungi and offers breathtaking views of the Sahyadri mountains. Devotees can reach the temple by climbing steps or using ropeway facilities."
    },
    {
        title: "Mahalakshmi Temple Dahanu",
        description:
            "Mahalakshmi Temple in Dahanu is another important Shakti Peeth located near the coastal region of Maharashtra. The temple is known for its serene environment and strong spiritual significance, attracting devotees from across the state."
    },
    {
        title: "Ambabai Temple Kolhapur Surroundings",
        description:
            "The surroundings of Ambabai Temple in Kolhapur are filled with spiritual energy, traditional markets, and cultural heritage. Devotees often explore nearby ghats, historical structures, and local food stalls while visiting this sacred Shakti Peeth."
    },
    {
        title: "Panchvati Nashik",
        description:
            "Panchvati in Nashik is a deeply spiritual destination associated with Lord Rama's exile period. It is home to several temples and sacred sites including Kalaram Temple, Sita Gufa, and Godavari Ghats, making it an essential stop in pilgrimage tours."
    },
    {
        title: "Tryambakeshwar Jyotirlinga",
        description:
            "Tryambakeshwar Jyotirlinga near Nashik is one of the twelve Jyotirlingas dedicated to Lord Shiva. The temple is famous for its unique three-faced lingam representing Brahma, Vishnu, and Mahesh. It is a major spiritual destination included in many Shakti Peeth and Jyotirlinga tour circuits."
    },
    {
        title: "Shani Shingnapur Temple",
        description:
            "Shani Shingnapur is a famous temple dedicated to Lord Shani known for its unique tradition of open-door houses. Devotees believe that Lord Shani protects the village, making it a highly visited spiritual destination included in pilgrimage tours."
    },
    {
        title: "Nanded Hazur Sahib",
        description:
            "Hazur Sahib in Nanded is one of the five Takhts in Sikhism and holds immense religious importance. The gurudwara marks the place where Guru Gobind Singh Ji spent his final days. It is a peaceful and spiritually significant destination for devotees."
    }
],



services: [
    {
        name: "Sade Teen Shakti Peeth Yatra from Pune",
        description:
            "Rising Cab Service offers Sade Teen Shakti Peeth Yatra from Pune with comfortable buses and tempo travellers for families, groups, and devotees. Our devotional tour packages cover the famous Shakti Peeths of Maharashtra with experienced drivers and flexible travel schedules."
    },
    {
        name: "Pune to Mahalaxmi Temple at Kolhapur bus Hire",
        description:
            "Book Pune to Mahalaxmi Temple at Kolhapur bus Hire with Rising Cab Service for religious tours, family trips, and group pilgrimages. We provide well-maintained buses with professional drivers for a safe and comfortable journey."
    },
    {
        name: "Pune to Tuljapur Tempo Traveller on Rent",
        description:
            "Rising Cab Service provides Pune to Tuljapur Tempo Traveller on Rent for temple visits and devotional travel. Our spacious and comfortable tempo travellers are ideal for family groups and pilgrimage tours."
    },
    {
        name: "Pune to Renuka Mata at Mahurgad Bus on Rent",
        description:
            "Hire a bus from Rising Cab Service for Pune to Renuka Mata at Mahurgad Bus on Rent and enjoy a comfortable pilgrimage with reliable transportation and experienced drivers."
    },
    {
        name: "Pune to Mahurgad Bus on Rent Package",
        description:
            "Rising Cab Service offers Pune to Mahurgad Bus on Rent Package for religious groups and family tours with customized itineraries and affordable pricing."
    },
    {
        name: "Pune to Saptashrungi mata vani Bus on Rent",
        description:
            "Book Pune to Saptashrungi mata vani Bus on Rent with Rising Cab Service for a convenient and memorable spiritual journey in comfortable buses."
    },
    {
        name: "bus hire for 3.5 shakti peeth yatra from pune",
        description:
            "Rising Cab Service provides bus hire for 3.5 shakti peeth yatra from pune with various seating capacities suitable for pilgrimage groups and devotional tours."
    },
    {
        name: "Mini bus on rent for sadeteen shakti peeth yatra",
        description:
            "Our Mini bus on rent for sadeteen shakti peeth yatra is perfect for small groups seeking comfortable and economical travel to Maharashtra's sacred Shakti Peeths."
    },
    {
        name: "14 17 20 25 Seater bus for pune to Sade Teen Shakti Peeth Yatra",
        description:
            "Rising Cab Service offers 14, 17, 20, and 25 seater buses for Pune to Sade Teen Shakti Peeth Yatra with comfortable seating and experienced drivers."
    },
    {
        name: "35 40 45 50 Seater bus for pune to Sade Teen Shakti Peeth Yatra",
        description:
            "Large groups can book 35, 40, 45, and 50 seater buses for Pune to Sade Teen Shakti Peeth Yatra with Rising Cab Service for safe and comfortable pilgrimage travel."
    },
    {
        name: "3.5 shakti peethas darshan in maharashtra",
        description:
            "Rising Cab Service organizes 3.5 shakti peethas darshan in maharashtra with customized travel packages and comfortable transportation for devotees."
    },
    {
        name: "tempo traveller on rent for sadeeteen shaktipeeth yatra",
        description:
            "Book a tempo traveller on rent for sadeeteen shaktipeeth yatra with Rising Cab Service for group travel and religious tours across Maharashtra."
    },
    {
        name: "sadeteen shaktipeeth tour from pune Bus Hire",
        description:
            "Rising Cab Service provides sadeteen shaktipeeth tour from pune Bus Hire with flexible travel plans and well-maintained vehicles for pilgrimage groups."
    },
    {
        name: "17 seater tempo traveller on rent for sadeteen shakti peeth yatra",
        description:
            "Hire a 17 seater tempo traveller on rent for sadeteen shakti peeth yatra from Rising Cab Service for comfortable family and group travel."
    },
    {
        name: "Shivswaraj Bus HireService Pune",
        description:
            "Rising Cab Service offers Shivswaraj Bus HireService Pune for devotional tours, religious events, and customized pilgrimage packages."
    },
    {
        name: "Shakti Peeth Yatra Bus Package Pune",
        description:
            "Our Shakti Peeth Yatra Bus Package Pune provides complete transportation solutions for devotees planning sacred tours across Maharashtra."
    },
    {
        name: "Pune Devotional Tour Bus Rentals",
        description:
            "Rising Cab Service provides Pune Devotional Tour Bus Rentals for temples, pilgrimage circuits, and religious group travel."
    },
    {
        name: "Pune Sade Teen Peeth Darshan Bus",
        description:
            "Book Pune Sade Teen Peeth Darshan Bus with Rising Cab Service for comfortable travel to Maharashtra's revered Shakti Peeths."
    },
    {
        name: "Luxury Bus for Shakti Peeth Tour",
        description:
            "Rising Cab Service offers Luxury Bus for Shakti Peeth Tour with premium seating and modern amenities for a comfortable pilgrimage."
    },
    {
        name: "Pune Religious Yatra Bus Hire",
        description:
            "Our Pune Religious Yatra Bus Hire service is ideal for temple tours, pilgrimage groups, and devotional travel with customized packages."
    },
    {
        name: "Pune Shakti Peeth Bus Package",
        description:
            "Rising Cab Service provides Pune Shakti Peeth Bus Package with affordable pricing and reliable transportation for devotees."
    },
    {
        name: "Pune Sade Teen Shakti Peeth Bus on Rent",
        description:
            "Book Pune Sade Teen Shakti Peeth Bus on Rent for family groups, religious organizations, and pilgrimage tours with comfortable travel arrangements."
    },
    {
        name: "Sade Teen Shakti Peeth Bus Rental Pune",
        description:
            "Rising Cab Service offers Sade Teen Shakti Peeth Bus Rental Pune with a fleet of mini buses, luxury buses, and tempo travellers for devotional journeys."
    }
],

tableData: [
    ["Sade Teen Shakti Peeth Yatra from Pune", "Pune to Mahalaxmi Temple at Kolhapur bus Hire"],
    ["Pune to Tuljapur Tempo Traveller on Rent", "Pune to Renuka Mata at Mahurgad Bus on Rent"],
    ["Pune to Mahurgad Bus on Rent Package", "Pune to Saptashrungi mata vani Bus on Rent"],
    ["bus hire for 3.5 shakti peeth yatra from pune", "Mini bus on rent for sadeteen shakti peeth yatra"],
    ["14 17 20 25 Seater bus for pune to Sade Teen Shakti Peeth Yatra", "35 40 45 50 Seater bus for pune to Sade Teen Shakti Peeth Yatra"],
    ["3.5 shakti peethas darshan in maharashtra", "tempo traveller on rent for sadeeteen shaktipeeth yatra"],
    ["sadeteen shaktipeeth tour from pune Bus Hire", "17 seater tempo traveller on rent for sadeteen shakti peeth yatra"],
    ["Shivswaraj Bus HireService Pune", "Shakti Peeth Yatra Bus Package Pune"],
    ["Pune Devotional Tour Bus Rentals", "Pune Sade Teen Peeth Darshan Bus"],
    ["Luxury Bus for Shakti Peeth Tour", "Pune Religious Yatra Bus Hire"],
    ["Pune Shakti Peeth Bus Package", "Pune Sade Teen Shakti Peeth Bus on Rent"],
    ["Sade Teen Shakti Peeth Bus Rental Pune", "Sade Teen Shakti Peeth Yatra from Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Specialized Sade Teen Shakti Peeth Bus Rental Service",
        WhyChoosedescription: "Rising Cab Service offers dedicated bus rental services for Pune Sade Teen Shakti Peeth Darshan, ensuring a comfortable and well-organized pilgrimage experience."
    },
    {
        WhyChooseheading: "Comfortable Buses for Group Travel",
        WhyChoosedescription: "Our fleet includes Mini Buses, AC Buses, Non-AC Buses, and luxury coaches suitable for religious groups, families, societies, and devotees."
    },
    {
        WhyChooseheading: "Customized Pilgrimage Tour Packages",
        WhyChoosedescription: "We provide flexible Sade Teen Shakti Peeth tour plans that can be customized according to group size, travel schedule, and darshan requirements."
    },
    {
        WhyChooseheading: "Affordable Bus Rental Packages",
        WhyChoosedescription: "Rising Cab Service offers cost-effective bus rental solutions with transparent pricing and complete travel support for religious tours."
    },
    {
        WhyChooseheading: "Experienced Drivers for Long-Distance Routes",
        WhyChoosedescription: "Our professional drivers are experienced in handling Maharashtra pilgrimage routes, ensuring safe and smooth travel throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Religious Groups and Families",
        WhyChoosedescription: "Our bus rental service is suitable for devotees, senior citizens, family groups, temple committees, and spiritual organizations."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "We provide bus pickup services from Pune City, Pimpri Chinchwad, Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, and nearby locations."
    },
    {
        WhyChooseheading: "Safe and Hassle-Free Pilgrimage Travel",
        WhyChoosedescription: "Rising Cab Service ensures clean buses, professional drivers, timely departures, and reliable travel arrangements for a peaceful darshan experience."
    }
]
};

const faqData = [
    {
        question: "What is the Pune Sade Teen Shakti Peeth Bus on Rent service?",
        answer: "This service provides buses on rent for devotees visiting Maharashtra's famous Sade Teen Shakti Peeth temples from Pune."
    },
    {
        question: "Which temples are covered in the Sade Teen Shakti Peeth tour?",
        answer: "The tour generally includes Kolhapur Mahalakshmi, Tuljapur Bhavani, Mahur Renuka Devi, and Saptashrungi Devi temples."
    },
    {
        question: "Do you provide buses for group pilgrimage tours?",
        answer: "Yes, Rising Cab Service provides buses for religious groups, families, societies, and temple organizations."
    },
    {
        question: "What types of buses are available?",
        answer: "We offer Mini Buses, AC Buses, Non-AC Buses, Luxury Coaches, and larger buses for group travel."
    },
    {
        question: "Can I book a customized Shakti Peeth tour package?",
        answer: "Yes, we provide customized pilgrimage itineraries according to your travel schedule and group requirements."
    },
    {
        question: "Is pickup available from Pimpri Chinchwad and Pune?",
        answer: "Yes, pickup services are available from Pune, Pimpri Chinchwad, and nearby locations."
    },
    {
        question: "Are buses suitable for senior citizens?",
        answer: "Yes, our buses are comfortable and suitable for senior citizens and family groups."
    },
    {
        question: "Do you provide multi-day pilgrimage packages?",
        answer: "Yes, we offer both short-duration and multi-day Sade Teen Shakti Peeth Darshan packages."
    },
    {
        question: "Are drivers experienced on pilgrimage routes?",
        answer: "Yes, our drivers regularly operate on Maharashtra's major pilgrimage routes and are familiar with temple destinations."
    },
    {
        question: "How can I book a Pune Sade Teen Shakti Peeth Bus on Rent?",
        answer: "You can book your bus through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sanjay Kulkarni",
        feedback:
            "Our Sade Teen Shakti Peeth Darshan tour was organized perfectly by Rising Cab Service. The bus was clean, spacious, and the entire journey was comfortable for all devotees.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Meena Patil",
        feedback:
            "We traveled with a large family group and had a wonderful pilgrimage experience. The driver was cooperative, the bus was well-maintained, and the trip was managed smoothly from start to finish.",
        rating: 5
    }
];



















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Sade Teen Shakti Peeth Bus on Rent",
"image": "https://www.risingcabservice.com/assets/images/pune-sade-teen-shakti-peeth-bus.jpg",
"description": "Book Pune Sade Teen Shakti Peeth Bus on Rent with Rising Cab Service for spiritual pilgrimage tours covering Mahalaxmi Kolhapur, Tuljapur, Mahurgad Renuka Mata, and Saptashrungi Vani. Enjoy comfortable buses, tempo travellers, and group travel packages.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-sade-teen-shakti-peeth-bus-on-rent"
}
};



    return (
        <div>

<Helmet>
  <title>Pune Sade Teen Shakti Peeth Bus on Rent | Yatra Package | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Sade Teen Shakti Peeth Bus on Rent for pilgrimage tours to Mahalaxmi Kolhapur, Tuljapur, Mahurgad Renuka Mata, and Saptashrungi Vani. Comfortable group travel with tempo travellers and buses."
/>

<meta
 name="keywords"
 content="Sade Teen Shakti Peeth Yatra from Pune, Pune to Mahalaxmi Temple at Kolhapur bus Hire, Pune to Tuljapur Tempo Traveller on Rent, Pune to Renuka Mata at Mahurgad Bus on Rent, Pune to Mahurgad Bus on Rent Package, Pune to Saptashrungi mata vani Bus on Rent, bus hire for 3.5 shakti peeth yatra from pune, Mini bus on rent for sadeteen, Pune Sade Teen Shakti Peeth Bus on Rent, Shakti Peeth Yatra Bus from Pune, Pune pilgrimage bus package"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punesadeteenshaktipeeth;